<template>
    <div class="main-container">
        <span>Advisories</span>
        <!-- v-tooltip binds mouse events only, so the explanation is repeated as real text. -->
        <span class="sr-only">Advisories are informational notes about potential privacy risks or situations to be aware of. They don't require action, just helpful context to keep you informed.</span>
        <PhQuestion
            :size="20"
            weight="fill"
            aria-hidden="true"
            v-tooltip.top="{
                value: `Advisories are informational notes about potential<br> privacy risks or situations to be aware of. They don't<br> require action, just helpful context to keep you informed.`,
                escape: false,
            }"
        />
    </div>
</template>
<script setup lang="ts"></script>
<style lang="scss" scoped>
.main-container {
    @apply flex items-center w-full gap-2;

    svg {
        @apply text-zinc-300 cursor-pointer hover:text-zinc-600;
    }

    span {
        @apply text-zinc-950 text-base font-semibold leading-normal;
    }
}
</style>
